// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"2f37dc49","358":"0fab6758","684":"18d8f3b3"}[chunkId] + ".chunk.css";
};